import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {RinnovoOffertaSummaryModule} from './rinnova-offerta-summary/rinnova-offerta-summary.module';
import {RinnovaOffertaModule} from './rinnova-offerta/rinnova-offerta.module';
import {RinnovaCodiceAttivazioneModule} from './rinnova-codice-attivazione/rinnova-codice-attivazione.module';
import {ImpotazioniModule} from './impostazioni/impostazioni.module';
import {GestioneProfiloLPModule} from './gestione-profilo-lp/gestione-profilo-lp.module';
import {GestioneProfiloModule} from './gestione-profilo/gestione-profilo.module';
import {GestioneOffertaModule} from './gestione-offerta/gestione-offerta.module';
import {DisdettaOffertaModule} from './disdetta-offerta/disdetta-offerta.module';
import {AnagraficaModule} from './anagrafica/anagrafica.module';
import {ChangePasswordModule} from './change-password/change-password.module';
import {ConfermaModule} from './conferma/conferma.module';
import {ChangePersonalFilesModule} from './change-personal-files/change-personal-files.module';
import {UnsubscribeModalModule} from './unsubscribe-modal/unsubscribe-modal.module';
import {UnsubscribeMessageModalModule} from './unsubscribe-message-modal/unsubscribe-message-modal.module';
import {AnagraficaDetailModalModule} from './anagrafica-detail-modal/anagrafica-detail-modal.module';
import {
  AnagraficaFilterModalInstanceModule
} from './anagrafica-filter-modal-instance/anagrafica-filter-modal-instance.module';
import {UploadLogoModalModule} from './upload-logo-modal/upload-logo-modal.module';
import {UserSettingsComponent} from './usersettings';
import {ViewStoricoConservazioneModule} from './view-storico-utilizzo/view-storico-utilizzo.module';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

  $stateProvider
    .state('usersettings', {
      abstract: true,
      url: '/usersettings',
      views: {
        'multiContent': {
          template: '<usersettings flex="100"></usersettings>'
        }
      }
    });
};

stateConfig.$inject = ['$stateProvider'];

export const UserSettingsModule: string = ng
  .module('usersettings', [
    'ui.bootstrap',
    'ncy-angular-breadcrumb',
    'ngAnimate',
    uiRouter,
    RinnovoOffertaSummaryModule,
    RinnovaOffertaModule,
    RinnovaCodiceAttivazioneModule,
    ImpotazioniModule,
    GestioneProfiloLPModule,
    GestioneProfiloModule,
    GestioneOffertaModule,
    DisdettaOffertaModule,
    AnagraficaModule,
    ChangePasswordModule,
    ConfermaModule,
    ChangePersonalFilesModule,
    UnsubscribeModalModule,
    UnsubscribeMessageModalModule,
    AnagraficaDetailModalModule,
    AnagraficaFilterModalInstanceModule,
    UploadLogoModalModule,
    ViewStoricoConservazioneModule,
  ])
  .component('usersettings', UserSettingsComponent)
  .config(stateConfig)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/usersettings.module.ts